"use client"

import { getNonUmbracoUrl } from "@/utils"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { mediaQueries, sizes } from "ui"
import ActionLinkCard from "ui/common/ActionLinkCard"

const StyledFiltersWrapper = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: ${sizes.baseDouble};
  width: 100%;
  ${mediaQueries.desktopM} {
    align-items: stretch;
    flex-direction: row;
    justify-content: center;
    gap: ${sizes.baseTriple};
  }
`

interface ActionCardListContainerProps {
  itemsList?: any[]
  onClick?: (title: string) => void
}

const ActionCardListContainer = ({
  itemsList,
  onClick,
}: ActionCardListContainerProps) => {
  return (
    <StyledFiltersWrapper>
      {itemsList?.map((item: any, index: number) => {
        const { primaryColor, link, icon, title, text } = item
        const cardData = {
          linkUrl: getNonUmbracoUrl(link?.href),
          linkTarget: link?.target,
          icon: icon?.src,
          title: title,
          text: text,
          primaryColor: primaryColor,
          id: item?.id,
          index,
          onClick: () => {
            onClick?.(title)
          },
        }
        return (
          <ActionLinkCard
            key={`card-${item?.id || ""}-${index}-${Date.now()}`}
            data={cardData}
          />
        )
      })}
    </StyledFiltersWrapper>
  )
}

export default ActionCardListContainer
